import theme from './module/theme';
import platform from './module/platform';
import webview from './module/webview';
import language from './module/language';
import common from './module/common';
import auth from './module/auth';
import filesystem from './module/filesystem';
import network from './module/network';
import download from './module/download';
import clipboard from './module/clipboard';
import appBridge, { ZoomAppBridgeError } from './module/app-bridge';
import history from './module/history';
import http from './module/http';
import apps from './module/apps';
import serviceHub from './module/service-hub';
import permissions from './module/permissions';
import mobile from './module/mobile';
import { isAvailable } from './module/utils';
import type {
  Response,
  NativeAPIResponseMessage,
  JSBridge,
} from './utils/type';
import {
  Bridge as bridge,
  config,
  compareVersions,
  platformBridgeChecker,
} from '@zoom/hybrid-jsbridge';
import { buildTime, version } from './version';

export type {
  Response,
  NativeAPIResponseMessage,
  JSBridge,
  ZoomAppBridgeError,
};

// TODO enable download api
export default {
  config,
  theme,
  auth,
  language,
  platform,
  webview,
  bridge,
  common,
  filesystem,
  network,
  download,
  clipboard,
  appBridge,
  history,
  http,
  apps,
  serviceHub,
  permissions,
  mobile,
  isAvailable,
  compareVersions,
  platformBridgeChecker,
  buildInfo: {
    buildTime,
    version,
  },
};
